<template>
    <div class="StepHead">
        <div class="Steps">
            <div class="StepsItem">3. 补充信息</div>
        </div>
        <!-- <div class="StepHeadTit">* 满足以下条件，可申请注册</div> -->
        <div class="StepComm">
            <div class="StepCommItem">
                <div class="StepCommNum">1.</div>
                <div class="StepCommHead">
                    <!-- 案例报告文件 - 所有类型都需要 -->
                    <div class="StepCommFile MarTop">
                        <div class="StepCommFileTit" v-if="user_group_id == '1'">案例报告文件（一份不少于3次咨询的案例报告）</div>
                        <div class="StepCommFileTit" v-if="user_group_id == '2'">案例报告文件（一份不少于6次咨询的案例报告）</div>
                        <div class="StepCommFileTit" v-if="user_group_id == '3'">案例报告文件（一份不少于12次咨询的案例报告）</div>
                        <div class="StepCommFileTit" v-if="user_group_id == '4'">督导报告文件</div>
                        <div class="StepCommFileTxt">
                            <el-button class="MarLe" type="primary" size="mini" @click="onDownloadTemplate">下载模板</el-button>
                            <el-upload action="none" :show-file-list="false" :accept="'.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp'" :http-request="(file) => UpFile(file, 'file')">
                              <el-button size="mini" class="MarLe" type="primary">上传</el-button>
                            </el-upload>
                            <div class="StepCommFileMsg">（上传pdf或图片格式文件）</div>
                            <div class="StepCommFileImg" v-if="SetData.file">
                                <img :src="$Global._isFileName(SetData.file)" alt="" @click="OpenLock(SetData.file)">
                                <i class="iconfont icon-guanbi2fill" @click="CloseImg('file')"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 逐字稿 - 所有类型都需要 -->
            <div class="StepCommItem">
                <div class="StepCommNum">2.</div>
                <div class="StepCommHead">
                    <div class="StepCommFile MarTop">
                        <div class="StepCommFileTit" v-if="user_group_id == '1' || user_group_id == '2' || user_group_id == '3'">一次完整个体咨询（50分钟）逐字稿（注：提交的逐字稿和上述案例报告文件须为同一个案）</div>
                        <div class="StepCommFileTit" v-if="user_group_id == '4'">一次完整个体督导案例逐字稿（注：提交的逐字稿和上述案例报告文件须为同一个案）</div>
                        <div class="StepCommFileTxt">
                            <el-upload action="none" :show-file-list="false" :accept="'.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp'" :http-request="(file) => UpFile(file, 'zixun_file')">
                              <el-button size="mini" class="MarLe" type="primary">上传</el-button>
                            </el-upload>
                            <div class="StepCommFileMsg">（注：无需提交录音或录像，仅需提交逐字稿）</div>
                            <div class="StepCommFileImg" v-if="SetData.zixun_file">
                                <img :src="$Global._isFileName(SetData.zixun_file)" alt="" @click="OpenLock(SetData.zixun_file)">
                                <i class="iconfont icon-guanbi2fill" @click="CloseImg('zixun_file')"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 科普文章 - 仅中级心理咨询师需要 -->
            <div class="StepCommItem" v-if="user_group_id == '2'">
                <div class="StepCommNum">3.</div>
                <div class="StepCommHead">
                    <div class="StepCommFile MarTop">
                        <div class="StepCommFileTit">公开发表的1篇心理卫生与健康专业论文或科普文章（需具备刊号）</div>
                        <div class="StepCommFileTxt">
                            <el-upload action="none" :show-file-list="false" :accept="'.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp'" :http-request="(file) => UpFile(file, 'lunwen_file')">
                              <el-button size="mini" class="MarLe" type="primary">上传</el-button>
                            </el-upload>
                            <!-- <div class="StepCommFileMsg">（上传文件pdf、jpg、doc等格式文件，需具备刊号）</div> -->
                            <div class="StepCommFileImg" v-if="SetData.lunwen_file">
                                <img :src="$Global._isFileName(SetData.lunwen_file)" alt="" @click="OpenLock(SetData.lunwen_file)">
                                <i class="iconfont icon-guanbi2fill" @click="CloseImg('lunwen_file')"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="StepCommItem" v-if="user_group_id == '3'">
                <div class="StepCommNum">3.</div>
                <div class="StepCommHead">
                    <div class="StepCommFile MarTop">
                        <div class="StepCommFileTit">公开发表的1篇心理健康、心理咨询、心理治疗相关专业论文（需具备刊号）</div>
                        <div class="StepCommFileTxt">
                            <div class="upload-section">
                                <div class="upload-item">
                                    <el-upload action="none" :show-file-list="false" :accept="'.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp'" :http-request="(file) => UpFile(file, 'lunwen_file')">
                                        <el-button size="mini" class="MarLe" type="primary">上传</el-button>
                                    </el-upload>
                                    <div class="StepCommFileImg" v-if="SetData.lunwen_file">
                                        <img :src="$Global._isFileName(SetData.lunwen_file)" alt="" @click="OpenLock(SetData.lunwen_file)">
                                        <i class="iconfont icon-guanbi2fill" @click="CloseImg('lunwen_file')"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="StepCommItem" v-if="user_group_id == '3'">
                <div class="StepCommNum">4.</div>
                <div class="StepCommHead">
                    <div class="StepCommFile MarTop">
                        <div class="StepCommFileTit">公开发表的2篇心理科普文章（需具备刊号）</div>
                        <div class="StepCommFileTxt">
                            <div class="upload-section upload-section-row">
                                <div class="upload-item">
                                    <el-upload action="none" :show-file-list="false" :accept="'.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp'" :http-request="(file) => UpFile(file, 'wenzhang1_file')">
                                        <el-button size="mini" class="MarLe" type="primary">上传</el-button>
                                    </el-upload>
                                    <div class="StepCommFileImg" v-if="SetData.wenzhang1_file">
                                        <img :src="$Global._isFileName(SetData.wenzhang1_file)" alt="" @click="OpenLock(SetData.wenzhang1_file)">
                                        <i class="iconfont icon-guanbi2fill" @click="CloseImg('wenzhang1_file')"></i>
                                    </div>
                                </div>
                                <div class="upload-item">
                                    <el-upload action="none" :show-file-list="false" :accept="'.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp'" :http-request="(file) => UpFile(file, 'wenzhang2_file')">
                                        <el-button size="mini" class="MarLe" type="primary">上传</el-button>
                                    </el-upload>
                                    <div class="StepCommFileImg" v-if="SetData.wenzhang2_file">
                                        <img :src="$Global._isFileName(SetData.wenzhang2_file)" alt="" @click="OpenLock(SetData.wenzhang2_file)">
                                        <i class="iconfont icon-guanbi2fill" @click="CloseImg('wenzhang2_file')"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="tip">注: <br>
                注册初级心理咨询师需提交一份不少于3次咨询的案例报告、一次完整个体咨询（50分钟）逐字稿；<br>
注册中级心理咨询师需提交一份不少于6次咨询的案例报告、一次完整个体咨询（50分钟）逐字稿，公开发表的1篇心理卫生与健康专业论文或科普文章（需具备刊号）；<br>
注册高级心理咨询师需提交一份不少于12次咨询的个案分析报告，公开发表的1篇心理健康、心理咨询、心理治疗相关专业论文或2篇心理科普文章（需具备刊号），一次完整个体咨询（50分钟）逐字稿；<br>
注册督导师需提交一份督导报告、一次完整个体督导案例逐字稿。
            </div> -->

            <div class="StepBtns">
                <div class="StepBtn" @click="ToggleStep('prve')" :class="{StpepDisabled:ConfigDisabled}">上一步</div>
                <div class="StepBtn" @click="ToggleStep('next')" :class="{StpepDisabled:ConfigDisabled}">保存本页并下一步</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ID:"",
                EdiId:"",
                SetData:{
                    file:"",
                    zixun_file:"",
                    article:"",
                    lunwen_file:"",
                    wenzhang1_file:"",
                    wenzhang2_file:"",
                    video_file:"",
                    password:"",
                },
                FormData:[],
                ConfigDisabled:false,
            }
        },
        props:{
            id:"",
            TypeId:"",
            PageDisabled:false,
            user_group_id:"",
        },
        mounted() {
            this.ID = this.id;
            this.ConfigDisabled = this.PageDisabled;
            if(this.$route.query.type){
                this.ConfigDisabled = false;
                var InfoData = JSON.parse(localStorage.getItem("InfoData"));
                this.ID = {id:InfoData.id};
                
                // 检查InfoData.case是否为空数组
                if(InfoData.case && InfoData.case.length > 0) {
                    // 如果有case数据，使用InfoData中的user_group_id
                    this.user_group_id = InfoData.user_group_id || this.user_group_id;
                    this.EdiId = InfoData.case[0].id;
                    this.SetData={
                        file:InfoData.case[0].file,
                        zixun_file:InfoData.case[0].zixun_file,
                        article:InfoData.case[0].article,
                        lunwen_file:InfoData.case[0].lunwen_file,
                        wenzhang1_file:InfoData.case[0].wenzhang1_file,
                        wenzhang2_file:InfoData.case[0].wenzhang2_file,
                        video_file:InfoData.case[0].video_file,
                        password:InfoData.case[0].password,
                    };
                } else {
                    // 如果case为空数组，使用页面的user_group_id，不设置SetData
                    this.getUserGroupId();
                }
            } else {
                // 非编辑模式，获取用户选择的注册类型
                this.getUserGroupId();
            }

            // 从 localStorage 读取保存的数据
            const savedData = localStorage.getItem('replenishInfoData');
            if(savedData) {
                const parsedData = JSON.parse(savedData);
                if(parsedData.TypeId == this.TypeId) {
                    this.SetData = parsedData.SetData;
                }
            }
        },
        methods: {
            getUserGroupId() {
                // 从localStorage获取用户选择的注册类型
                const specialtyInfoData = localStorage.getItem('specialtyInfoData');
                if(specialtyInfoData) {
                    const parsedData = JSON.parse(specialtyInfoData);
                    if(parsedData.user_group_id) {
                        this.user_group_id = parsedData.user_group_id;
                    }
                }
            },
            UpFile({ file }, fileType) {
                var fd = new FormData()
                fd.append('file', file);
                this.$Global.FileUpData(fd, (res) => {
                    this.SetData[fileType] = res.data.url;
                    this.$forceUpdate();
                })
            },
            GetFormData(val){
                this.$get("api/join_in/getRegisterInformation",{
                    page:3,
                    user_group_id:val,
                }).then(res => {
                     if(res.data.code == 1){
                         this.FormData = res.data.data;
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })  
            },
            ToggleStep(s){
                if(this.ConfigDisabled){return;}
                
                // 保存表单数据到 localStorage
                const formData = {
                    TypeId: this.TypeId,
                    SetData: this.SetData
                };
                localStorage.setItem('replenishInfoData', JSON.stringify(formData));
                
                if(s=="next"){
                    // 验证必填项
                    if(!this.SetData.file) {
                        this.$message.error("请上传案例报告文件");
                        return;
                    }
                    
                    if(!this.SetData.zixun_file) {
                        this.$message.error("请上传逐字稿");
                        return;
                    }
                    
                    // 中级和高级心理咨询师需要上传科普文章
                    if(this.user_group_id == '2' && !this.SetData.lunwen_file) {
                        this.$message.error("请上传专业论文或科普文章");
                        return;
                    }
                    
                    if(this.user_group_id == '3') {
                        const hasPaper = !!this.SetData.lunwen_file;
                        const hasTwoPopular = !!this.SetData.wenzhang1_file && !!this.SetData.wenzhang2_file;
                        if(!(hasPaper || hasTwoPopular)) {
                            this.$message.error("请上传一篇专业论文或两篇科普文章");
                            return;
                        }
                    }
                    
                    var Quy = JSON.parse(JSON.stringify(this.SetData));
                    var Url = "api/join_in/caseReport";
                    Quy.register_professional_id=this.ID.id;
                    Quy.id =this.EdiId;

                    this.$post(Url,Quy).then(res => {
                         if(res.data.code == 1){
                             this.$message.success(res.data.msg);
                             this.$emit("PageBtn","next")
                         }else{
                             this.$message.error(res.data.msg)
                         }
                    })
                }else{
                    this.$emit("PageBtn","prve")
                }
            },
            OpenLock(res){
                this.$Global.previewFile(res)
            },
            CloseImg(fileType){
                this.SetData[fileType] = "";
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
            OpenWeb() {
                window.open('https://pan.baidu.com/')
            },
            Open() {
                if (this.SetData.video_file && this.SetData.video_file.startsWith("https://pan.baidu.com/")) {
                window.open(this.SetData.video_file);
                } else if (this.SetData.video_file) {
                this.$message.error("网盘地址不正确，请输入正确的百度网盘地址！");
                } else {
                        this.$message.error("请输入网盘地址！");
                }
            },
            onDownloadTemplate() {
                const filteredUrl = localStorage.getItem("filteredUrl");
                if (!filteredUrl) {
                    this.$message.error("请先注册并选择所需注册类型再下载模板文件");
                    return;
                }
                window.open(this.$Global.CommImgHttp + filteredUrl);
            }
        },
    }
</script>

<style scoped>
    .MarTop {
        margin-top: 20px;
    }
    .MarLe{
        margin-left: 10px;
    }
    .Steps{
        display: none;
        align-items: center;
        margin: 30px 0;
        display: none;
    }
    .StepsItem{
        flex: 1;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #F5F5F5;
        position: relative;
        font-weight: 400;
        font-size: 18px;
        color: #999;
    }
    .StepHeadtit{
        padding: 10px 20px;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        background: #f5f5f5;
        margin-bottom: 20px;
    }
    .StepCommItem{
        display: flex;
        align-items: baseline;
    }
    .StepCommNum{
        font-weight: 400;
        font-size: 20px;
        color: #000000;
    }
    .StepCommHead{
        margin-left: 20px;
        flex: 1;
    }
    .StepCommHead .tip {
        margin-top: 10px;
        color: #999999;
    }
    .StepCommHead .tipColor {
        color: red;
    }
    .StepCommHead .tip .tipUrl{
        cursor: pointer;
        color: red;
    }
    .StepCommFile{
        font-weight: 400;
        font-size: 16px;
        color: #666;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .StepCommFileTxt{
        display: flex;
        align-items: center;
    }
    .StepCommFileBtn{
        padding: 3px 35px;
        background: #0185eb;
        border-radius: 5px;
        border: 1px solid #0185eb;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        /* margin-left: 20px; */
        color: #fff;
    }
    .StepCommFileMsg{
        font-weight: 400;
        font-size: 16px;
        color: #999999;
    }
    .StepCommFileLock{
        font-size: 16px;
        color: #0385EB;
        padding: 0 10px;
    }
    .StepCommFileImg{
        border: 1px solid #ddd;
        padding: 2px;
        cursor: pointer;
        position: relative;
        margin: 0 10px;
        display: inline-block;
    }
    .StepCommFileImg img{
        width: 50px;
        height: 50px;
        display: block;
    }
    .StepCommFileImg .iconfont{
        position: absolute;
        top: -8px;
        right: -8px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        background-color: #ff4d4f;
        border-radius: 50%;
        cursor: pointer;
        z-index: 9;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .StepCommFileImg .iconfont::before {
        content: "×";
        font-size: 14px;
        font-weight: bold;
        transform: scale(1.2);
    }
    .StepCommFileImg .iconfont:hover {
        background-color: #ff7875;
    }
    .StepCommIpt{
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #666;
    }
    .StepCommIptVal{
        width: 120px;
        margin: 0 10px;
    }
    .StepCommIptVal.Wid500{
        width: 40%;
    }
    .StepCommIptMsg{
        margin-left: 10px;
        font-weight: 400;
        font-size: 16px;
        color:#0385EB;
        display: none;
    }
    .StepCommIpts{
        display: flex;
        align-items: baseline;
    }
    .StepCommIptsDis{
        display: flex;
        align-items: baseline;
    }
    .StepCommIptsTit{
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        margin-right:20px;
    }
    .StepCommIptsHref{
        width: 65%;
    }
    .StepCommIptsHrefDis{
        flex: 1;
        margin-right: 40px;
    }
    .StepCommIptsHrefMsg{
        margin-top: 10px;
        cursor: pointer;
        font-weight: 400;
        font-size: 16px;
        color:#0385EB;
    }
    .StepCommIptsPass{
        flex: 1;
    }
    .StepBtns{
        display: flex;
        align-items: center;
        justify-content: center;
        margin:  30px 0;
        padding-top: 8vw;
    }
    .StepBtn{
        margin-right: 20px;
        width: 180px;
        text-align: center;
        padding: 7px 15px;
        color: #fff;
        font-size: 18px;
        background: #0286eb;
        border-radius: 20px;
        cursor: pointer;
    }
    .StepBtn.StpepDisabled{
        background: #80c1f3;
        cursor: no-drop;
    }
    @media only screen and (max-width: 550px) {
       .Steps{
           display: flex;
       }
       .StepHeadtit{
           margin-bottom: 10px;
       }
       .StepCommFileDis{
           display: block;
       }
       .StepCommFileTxt{
           flex-wrap: wrap;
           font-size:18px;
           margin-top: 10px;
       }
       .StepCommFileDis .StepCommFileTxt{
           margin-top: 10px;
       }
       .StepCommItem{
           margin-top: 20px;
       }
       .StepCommFile,
       .StepCommIpt{
           font-size:18px;
           flex-wrap: wrap;
       }
    }
    .upload-section {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
    .upload-item {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
    }
    .upload-item:last-child {
        margin-bottom: 0;
    }
    .required-mark {
        color: #d51938;
        margin-right: 5px;
    }
    .upload-section.upload-section-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 30px;
    }
    .upload-section.upload-section-row .upload-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        margin-bottom: 0; /* 添加这行来覆盖默认的 margin-bottom */
    }
</style>